import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import styled from "styled-components";
import { getHomeSlider2 } from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import { showToast } from "../../../Utills/toast";
import CustomTable from "../../Common/DataTable/DataTable";
export default function Slider2View() {

  const { id, partnerId } = useParams();

  const [slidetwo, setSlidetwo] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchSlider2 = async () => {
    setIsLoading(true);
    if (!Number(id)) {
      setIsLoading(false);
      return;
    }
    try {
      const response = await getHomeSlider2(id);
      setSlidetwo(response.data.data[0]);
    } catch (error) {
      showToast({
        type: 'error',
        message: error.response.data.message || 'Failed to fetch slider 2. Please try again.',
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSlider2();
  }, [id]);

  const columns = ["Logo number", "Logo"];
  const rows = [];

  if (slidetwo && Object.keys(slidetwo).length > 0) {
    rows.push(["Logo 1", slidetwo.logo1 ?  <img src={slidetwo.logo1} alt="slider 1" width="150" /> : null]);
    rows.push(["Logo 2", slidetwo.logo2 ?  <img src={slidetwo.logo2} alt="slider 2" width="150" /> : null]);
    rows.push(["Logo 3", slidetwo.logo3 ?  <img src={slidetwo.logo3} alt="slider 3" width="150" /> : null]);
  }

  return (
<>
{isLoading ? <CmsCircularProgress/> : <ContentWrapper>
      <HomeTitle>Slider 2 Section</HomeTitle>
      <CustomTable
          columns={columns}
          rows={rows}
          isLoading={isLoading}
        />
      <ButtonWrapper>
        <Link to={`/${partnerId}/home`}>
          <Button variant="secondary">Go Back</Button>
        </Link>
        <Link to={`/${partnerId}/home/slider2/edit/${id}`}>
          <Button>{Number(id) ? 'Edit' : 'Add'}  Slider 2 section</Button>
        </Link>
      </ButtonWrapper>
    </ContentWrapper>}
</>
  );
}

const ContentWrapper = styled.div`
   @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
  justify-content: center;
`;

const HomeTitle = styled.h3`
  text-align: center;
  padding: 10px 0;
`;



const ButtonWrapper = styled.div`
  margin: 0 auto;
  padding-top: 40px;
  display: flex;
  gap: 5rem;
  justify-content: center;
   @media (max-width: 890px) {
   justify-content: end;
    gap: 2rem;
  }
 @media (max-width: 425px) {
  gap: 1rem;
}
`;
